import React from 'react';
import { Badge } from 'evergreen-ui';

export  const Badges = props => {
  if (typeof props.arr === 'undefined') return null;
  return props.arr.map((val, idx) => {
    return <Badge key={idx} color="neutral" marginRight={props.mr || 0}>{ val }</Badge>
  })
}